import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.content.'

@vsingleton()
export class AdminContentStatisticsRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'statistics.'

  exportExcel() {
    return this.ziggyRoute('export')
  }
}